<template>
  <v-row align="center" justify="center">
    <v-col md="6">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>
          Create Sortition
        </v-card-title>
        <v-card-text>
          <validation-observer ref="validationObserver" slim>
            <sortition-form
              ref="form"
              v-model="sortition"
              :params="params"
              @submit="createSortition"
            >
            </sortition-form>
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="
                $router.push({ name: $routes.admin.sortition.indexRoute.name })
              "
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="createSortition">
              Create
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { createSortition } from '@/api/sortition.api.js';
import SortitionCreateUpdate from "./SortitionCreateUpdate.js";

export default {
  name: "SortitionCreate",
  extends: SortitionCreateUpdate,
  async mounted() {
    this.$startLoading();
    await this.fetchParams();
    this.sortition.schedules = this.params.weekdays.map(weekday => ({
      weekday: weekday.id,
      time: null
    }));
    this.$finishedLoading();
  },
  methods: {
    async createSortition() {
      const valid = await this.$refs.validationObserver.validate();

      if (valid) {
        const { sortition, $routes, $router } = this;

        createSortition(sortition)
          .then(() => {
            $router.push({ name: $routes.admin.sortition.indexRoute.name });
          })
          .catch(error =>
            this.handleErrorResponse(this.$refs.validationObserver, error)
          );
      }
    }
  }
};
</script>

<style scoped></style>
